'use client'

// Mixed-weight, mixed-family headline: display font + Instrument Serif italic accents.
// Words come from messages.hero.headline so each locale controls which word sits
// in the italic-accent slot without touching this file. Empty fields (e.g. line2Post
// in Spanish) render nothing and the flex/inline layout closes the gap naturally.

import { useTranslations } from 'next-intl'

export function HeroHeadline() {
  const t = useTranslations('hero.headline')

  const sans = (weight: number) => ({
    fontFamily: 'var(--font-display)',
    fontWeight: weight,
    letterSpacing: '-0.035em',
    display: 'inline-block' as const,
  })

  const serif = {
    fontFamily: 'var(--font-serif)',
    fontStyle: 'italic' as const,
    fontWeight: 400,
    fontSize: '1.06em',
    color: 'var(--olive-600)',
    letterSpacing: '-0.025em',
    display: 'inline-block' as const,
    marginLeft: '0.04em',
    marginRight: '0.22em',
  }

  const word = (key: string) => {
    const v = t(key)
    return v ? v : null
  }

  return (
    <h1
      id="hero-headline"
      style={{
        fontFamily: 'var(--font-display)',
        fontSize: 'clamp(56px, 7.8vw, 122px)',
        lineHeight: 1.03,
        letterSpacing: '-0.03em',
        color: 'var(--earth-700)',
        fontWeight: 500,
        margin: 0,
        maxWidth: '16ch',
      }}
    >
      {/* Line 1 */}
      <span style={{ display: 'block' }}>
        {word('line1Pre')   && <><span style={sans(400)}>{word('line1Pre')}</span>{' '}</>}
        {word('line1Italic') && <span style={serif}>{word('line1Italic')}</span>}
        {word('line1Post')  && <span style={sans(700)}>{word('line1Post')}</span>}
      </span>

      {/* Line 2 */}
      <span style={{ display: 'block' }}>
        {word('line2Pre')   && <><span style={sans(400)}>{word('line2Pre')}</span>{' '}</>}
        {word('line2Italic') && <span style={serif}>{word('line2Italic')}</span>}
        {word('line2Post')  && <span style={sans(400)}>{word('line2Post')}</span>}
      </span>

      {/* Line 3 — "future of soil." with a lime period */}
      <span style={{ display: 'block' }}>
        {word('line3Pre')  && <><span style={sans(500)}>{word('line3Pre')}</span>{' '}</>}
        {word('line3Mid')  && <><span style={sans(400)}>{word('line3Mid')}</span>{' '}</>}
        {word('line3Post') && <span style={sans(700)}>{word('line3Post')}</span>}
        <span style={{ color: 'var(--lime-500)', fontWeight: 800 }}>.</span>
      </span>
    </h1>
  )
}
